module.exports = __webpack_public_path__ + "img/NAV-alt.09f9fcbb.svg";